import React, { memo } from 'react';
import {
  getUserAvatarUrl,
  getUserFullName,
  getUserInitials,
  getUserRoleLabel
} from '../../utils/userIdentity';

const SIZE_MAP = {
  xs: { box: 'h-7 w-7', text: 'text-xs', role: 'text-[10px]' },
  sm: { box: 'h-9 w-9', text: 'text-sm', role: 'text-[11px]' },
  md: { box: 'h-10 w-10', text: 'text-sm', role: 'text-xs' },
  lg: { box: 'h-12 w-12', text: 'text-base', role: 'text-xs' },
  xl: { box: 'h-24 w-24', text: 'text-4xl', role: 'text-sm' }
};

/**
 * Avatar + identidad compacta — consume currentUser vía prop user.
 */
const UserAvatar = memo(function UserAvatar({
  user,
  size = 'sm',
  showMeta = false,
  className = '',
  metaClassName = ''
}) {
  const tokens = SIZE_MAP[size] || SIZE_MAP.sm;
  const avatarUrl = getUserAvatarUrl(user);
  const initials = getUserInitials(user);
  const fullName = getUserFullName(user);
  const role = getUserRoleLabel(user);

  const avatarNode = (
    <div
      className={`${tokens.box} shrink-0 overflow-hidden rounded-full bg-e0e3-accent/20 ring-1 ring-white/10 ${className}`}
      title={fullName}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        <span className={`flex h-full w-full items-center justify-center font-bold text-e0e3-accent ${tokens.text}`}>
          {initials}
        </span>
      )}
    </div>
  );

  if (!showMeta) return avatarNode;

  return (
    <div className={`flex min-w-0 items-center gap-2 ${metaClassName}`}>
      {avatarNode}
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold leading-tight text-white">{fullName}</p>
        {role && (
          <p className={`truncate text-e0e3-muted ${tokens.role}`}>{role}</p>
        )}
      </div>
    </div>
  );
});

export default UserAvatar;
